// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import "./ExamInstructions.css";
// import { Card, duration } from "@mui/material";
// import axios from "axios";
// import ConfirmStartDialog from "./ConfirmStartDialog"; // ⬅️ import here
// import config from "../config";
// import "../Final_Css/positiveflowbuttons.css";

// const ExamInstructions = ({ onStart, onClose, examData }) => {
//   const [isChecked, setIsChecked] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [showConfirm, setShowConfirm] = useState(false);
//   const navigate = useNavigate();
//   const [instructions, setInstructions] = useState([]);


//   useEffect(() => {
//     if (!examData?.ExamEmployeeId) return;

//     const fetchInstructions = async () => {
//       try {
//         const res = await axios.get(
//           `/employee/instructions/?exam_employee_id=${examData.ExamEmployeeId}`,
//           { withCredentials: true }
//         );

//         console.log("📌 Instructions API:", res.data);

//         const raw = res.data.instructions?.[0]?.Instructions;
//         if (!raw) return setInstructions([]);

//         const parsed = JSON.parse(raw); // parsed = entire sections array
//         setInstructions(parsed); // store full object list

//       } catch (err) {
//         console.error("Error fetching instructions:", err);
//         setInstructions([]);
//       }
//     };

//     fetchInstructions();
//   }, [examData]);




//   const handleProceed = async () => {
//     try {
//       setLoading(true);
//       if (!examData) return alert("No Assessment data found!");

//       const payload = {
//         exam_id: examData.examId,
//         exam_title: examData.ExamTitle,
//         area: examData.area,
//         topic: examData.topic,
//         subtopic: examData.subtopic
//       };

//       console.log("Starting Assessment with payload:", payload);
//       await axios.post(`/exam/submit-exam/`, payload, {
//         withCredentials: true, // ✅ include cookies in the request
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });

//       // ✅ POST done, show confirm dialog
//       setShowConfirm(true);

//       if (onStart) onStart(); // optional flag for parent
//     } catch (err) {
//       console.error(err);
//       alert("Failed to start Assessment. Try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Instead of starting exam directly, first show confirm dialog
//   const handleConfirmStart = () => {
//     setShowConfirm(false);

//     // ✅ Either navigate directly here...
//     navigate("/assignment", { state: examData });

//     // ✅ ...or let parent know via onStart (optional)
//     if (onStart) onStart();
//   };

//   const handleCancelConfirm = () => {
//     setShowConfirm(false);
//   };

//   return (
//     <>
//       <div className="exam-popup-overlay">
//         <Card className="exam-popup-container">
//           <header className="exam-instructions-header">
//             <h2>Theory Assessment Instructions</h2>
//           </header>

//           <main className="exam-instructions-body">
//             {instructions.length > 0 ? (
//               instructions.map((section, idx) => (
//                 <div key={idx} className="instruction-section">

//                   {/* Heading */}
//                   {section.heading && (
//                     <h3 className="instruction-heading">{section.heading}</h3>
//                   )}

//                   {/* Bullet Points */}
//                   <ol className="instruction-list">
//                     {section.points?.map((point, i) => (
//                       <li key={i} className="instruction-item">
//                         {point}
//                       </li>
//                     ))}
//                   </ol>

//                 </div>
//               ))
//             ) : (
//               <p>No instructions available</p>
//             )}

//             {/* Checkbox + Buttons as before */}
//             <div className="checkbox-container">
//               <input
//                 type="checkbox"
//                 id="confirm-read"
//                 checked={isChecked}
//                 onChange={() => setIsChecked(!isChecked)}
//                 style={{ accentColor: "var(--theme-accent)" }}
//               />
//               <label htmlFor="confirm-read">I have read and understood the instructions</label>
//             </div>

//             <div className="buttons-container">
//               <button
//                 className="btn-negative"
//                 onClick={onClose || (() => navigate(-1))}
//               >
//                 Cancel
//               </button>

//               <button
//                 className="btn"
//                 disabled={!isChecked || loading}
//                 onClick={handleProceed}
//               >
//                 {loading ? "Processing..." : "Proceed"}
//               </button>
//             </div>
//           </main>

//         </Card>
//       </div>

//       {/* ✅ Show Confirmation Dialog */}
//       {showConfirm && (
//         <ConfirmStartDialog
//           loading={loading}
//           onCancel={handleCancelConfirm}
//           onConfirm={handleConfirmStart}
//         />
//       )}
//     </>
//   );
// };

// export default ExamInstructions;



import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./ExamInstructions.css";
import { Card, duration } from "@mui/material";
import axios from "axios";
// import ConfirmStartDialog from "./ConfirmStartDialog"; // ⬅️ import here
import config from "../config";
import "../Final_Css/positiveflowbuttons.css";

const ExamInstructions = ({ onStart, onClose, examData }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();
  const [instructions, setInstructions] = useState([]);

  const examStatus = examData?.status || "Start";


  useEffect(() => {
    if (!examData?.ExamEmployeeId) return;
    console.log(examData, "examData")

    const fetchInstructions = async () => {
      try {
        const res = await axios.get(
          `/employee/instructions/?exam_employee_id=${examData.ExamEmployeeId}`,
          { withCredentials: true }
        );

        console.log("📌 Instructions API:", res.data);

        const raw = res.data.instructions?.[0]?.Instructions;
        if (!raw) return setInstructions([]);

        const parsed = JSON.parse(raw); // parsed = entire sections array
        setInstructions(parsed); // store full object list

      } catch (err) {
        console.error("Error fetching instructions:", err);
        setInstructions([]);
      }
    };

    fetchInstructions();
  }, [examData]);




  // const handleProceed = async () => {
  //   try {
  //     setLoading(true);
  //     if (!examData) return alert("No Assessment data found!");

  //     const payload = {
  //       exam_id: examData.examId,
  //       exam_title: examData.ExamTitle,
  //       area: examData.area,
  //       topic: examData.topic,
  //       subtopic: examData.subtopic
  //     };

  //     console.log("Starting Assessment with payload:", payload);
  //     await axios.post(`/exam/submit-exam/`, payload, {
  //       withCredentials: true, // ✅ include cookies in the request
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     // ✅ POST done, show confirm dialog
  //     setShowConfirm(true);

  //     if (onStart) onStart(); // optional flag for parent
  //   } catch (err) {
  //     console.error(err);
  //     alert("Failed to start Assessment. Try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // ✅ Instead of starting exam directly, first show confirm dialog

  const handleProceed = async () => {

    try {

      setLoading(true);

      if (!examData) {
        alert("No Assessment data found!");
        return;
      }

      const payload = {
        exam_id: examData.examId,
        exam_title: examData.ExamTitle,
        area: examData.area,
        topic: examData.topic,
        subtopic: examData.subtopic,
        exam_purpose: examData.examPurpose,
        status: examData.status 
      };

      console.log("Starting Assessment with payload:", payload);

      const response = await axios.post(
        `/exam/submit-exam/`,
        payload,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Submit Exam Response:", response.data);

      // DIRECT NAVIGATION
      navigate("/assignment", {
        state: {
          examData: response.data
        }
      });

    } catch (err) {
      console.error(err);
      const errorMessage =
        err.response?.data?.details?.message ||   // nested backend error
        err.response?.data?.error ||            // direct backend error
        err.response?.data?.message ||          // fallback message
        "Failed to start Assessment. Try again.";
      alert(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // const handleConfirmStart = () => {
  //   setShowConfirm(false);

  //   // ✅ Either navigate directly here...
  //   navigate("/assignment", { state: examData });

  //   // ✅ ...or let parent know via onStart (optional)
  //   if (onStart) onStart();
  // };

  // const handleCancelConfirm = () => {
  //   setShowConfirm(false);
  // };

  return (
    <>
      <div className="exam-popup-overlay">
        <Card className="exam-popup-container">
          <header className="exam-instructions-header">
            <h2>Theory Assessment Instructions</h2>
          </header>

          <main className="exam-instructions-body">
            {instructions.length > 0 ? (
              instructions.map((section, idx) => (
                <div key={idx} className="instruction-section">

                  {/* Heading */}
                  {section.heading && (
                    <h3 className="instruction-heading">{section.heading}</h3>
                  )}

                  {/* Bullet Points */}
                  <ol className="instruction-list">
                    {section.points?.map((point, i) => (
                      <li key={i} className="instruction-item">
                        {point}
                      </li>
                    ))}
                  </ol>

                </div>
              ))
            ) : (
              <p>No instructions available</p>
            )}

            {/* Checkbox + Buttons as before */}
            <div className="checkbox-container">
              <input
                type="checkbox"
                id="confirm-read"
                checked={isChecked}
                onChange={() => setIsChecked(!isChecked)}
                style={{ accentColor: "var(--theme-accent)" }}
              />
              <label htmlFor="confirm-read">I have read and understood the instructions</label>
            </div>

            <div className="buttons-container">
              <button
                className="btn-negative"
                onClick={onClose || (() => navigate(-1))}
              >
                Cancel
              </button>

              <button
                className="btn"
                disabled={!isChecked || loading}
                onClick={handleProceed}
              >
                {loading
                  ? (examStatus === "Resume" ? "Resuming..." : "Processing...")
                  : (examStatus === "Resume" ? "Resume Assessment" : "Start Assessment")
                }
              </button>
            </div>
          </main>

        </Card>
      </div>

      {/* ✅ Show Confirmation Dialog */}
      {/* {showConfirm && (
        <ConfirmStartDialog
          loading={loading}
          onCancel={handleCancelConfirm}
          onConfirm={handleConfirmStart}
        />
      )} */}
    </>
  );
};

export default ExamInstructions;
